import * as React from "react";
import { index } from "../../../routes/org";
import { Link } from "@mui/material";
import Image from "next/legacy/image";
import cvkLogo from "../../../../public/cvk/logo.png";
import { InternalLink } from "../../common/Link";
import { Subdomain } from "../../../utils/subdomain/subdomain";

interface Props {
    subdomain: Subdomain;
}

export const CvkLogo = (p: Props) => {
    return (
        <>
            <InternalLink
                href={index.route({
                    subdomain: p.subdomain,
                })}
            >
                <Link>
                    <Image
                        src={cvkLogo}
                        width={172}
                        height={80}
                        alt={"Českoveský kros"}
                    />
                </Link>
            </InternalLink>
        </>
    );
};
